// TODO: Use Bouqs UI component instead https://chakra-ui.com/docs/disclosure/visually-hidden
import VisuallyHidden from './VisuallyHidden';

export default VisuallyHidden;
